import {
  IBodyMultimediaFetch,
  TInitialMultimediaState,
} from 'interfaces/multimedia.interface';
import {
  bannerType,
  imageType,
  videoType,
} from 'views/pages/main/multimediaPage/components/constants';

export const mediaDefaultLimit = 15;

const bodyMultimediaImagesFetch: IBodyMultimediaFetch = {
  options: {
    brand_id: [],
    multimedia_type: [imageType],
    search: [],
    limit: mediaDefaultLimit,
    index: 0,
  },
  filter: {
    tag: [],
    product: [],
    division: [],
    gender: [],
    country: [],
    season: [],
  },
};
const bodyMultimediaBannersFetch: IBodyMultimediaFetch = {
  options: {
    brand_id: [],
    multimedia_type: [bannerType],
    search: [],
    limit: mediaDefaultLimit,
    index: 0,
  },
  filter: {
    tag: [],
    product: [],
    division: [],
    gender: [],
    country: [],
    season: [],
  },
};
const bodyMultimediaVideosFetch: IBodyMultimediaFetch = {
  options: {
    brand_id: [],
    multimedia_type: [videoType],
    search: [],
    limit: mediaDefaultLimit,
    index: 0,
  },
  filter: {
    tag: [],
    product: [],
    division: [],
    gender: [],
    country: [],
    season: [],
  },
};

const initialMultimediaState: TInitialMultimediaState = {
  image: {
    items: [],
    itemSelected: null,
    bodyMultimediaFetch: bodyMultimediaImagesFetch,
    isLoading: true,
    isLoadingMoreMedia: false,
    thereAreMoreMedia: true,
    search: {
      media: [],
      query: '',
    },
    brandSelected: null,
  },
  video: {
    items: [],
    itemSelected: null,
    bodyMultimediaFetch: bodyMultimediaVideosFetch,
    isLoading: true,
    isLoadingMoreMedia: false,
    thereAreMoreMedia: true,
    search: {
      media: [],
      query: '',
    },
    brandSelected: null,
  },
  banner: {
    items: [],
    itemSelected: null,
    bodyMultimediaFetch: bodyMultimediaBannersFetch,
    isLoading: true,
    isLoadingMoreMedia: false,
    thereAreMoreMedia: true,
    search: {
      media: [],
      query: '',
    },
    brandSelected: null,
  },
  videosByBrand: [],
  getVideosByBrand: () => {},
  getMedia: () => {},
  getMoreMedia: () => {},
  setBrandSelected: () => {},
  searchMedia: () => {},
};

export default initialMultimediaState;
